import {html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import './projects-physics';
import './projects-page';
import './project-page';
import './app-link';
import './page-footer';
import './global-header';
import {intlPath, NAVIGATE_EVENT, PHYSICS_NAVIGATE_EVENT} from './utils';
import {NAME_LABEL} from './labels';

const HERO_HIDDEN_CLASS = 'hidden';

@customElement('main-app')
export class MainAppElement extends LitElement {
  @property({type: String})
  url = window.location.pathname;

  imagepos: {x: number; y: number; h: number; w: number} | null = null;

  projects: {id: string; title: string; content: string}[] = [];

  _hero = document.getElementById('hero');

  protected firstUpdated() {
    this.addEventListener(
      NAVIGATE_EVENT,
      e => {
        this.url = intlPath((e as CustomEvent).detail);
        window.history.pushState(null, '', this.url);
        this.imagepos = null;
        this.requestUpdate();
      },
      false
    );
    this.addEventListener(
      PHYSICS_NAVIGATE_EVENT,
      e => {
        const detail = (e as CustomEvent).detail;
        this.url = intlPath(detail.url);
        this.imagepos = detail.pos;
        window.history.pushState(null, '', this.url);
        this.requestUpdate();
      },
      false
    );
    window.addEventListener(
      'popstate',
      () => {
        this.url = window.location.pathname;
        this.requestUpdate();
      },
      false
    );

    const lang = document.documentElement.lang || 'en';
    fetch(`/intl/${lang}/projects.json`)
      .then(res => res.json())
      .then(data => {
        this.projects = data['projects'];
        this.requestUpdate();
      });
  }

  render() {
    document.body.style.cursor = 'default';
    const projectsMatch = this.url.match(/\/projects\/([\w-]+)?\/?/);
    const projectId =
      projectsMatch && projectsMatch.length > 1 ? projectsMatch[1] : null;
    const project = projectId
      ? this.projects.filter(item => item.id === projectId)[0]
      : null;

    if (this._hero) {
      if (projectsMatch) {
        this._hero.classList.add(HERO_HIDDEN_CLASS);
      } else {
        document.title = NAME_LABEL();
        this._hero.classList.remove(HERO_HIDDEN_CLASS);
      }
    }

    const imageX = this.imagepos ? this.imagepos.x : 0;
    const imageY = this.imagepos ? this.imagepos.y : 0;
    const imageW = this.imagepos ? this.imagepos.w : 0;
    const imageH = this.imagepos ? this.imagepos.h : 0;

    return html`
      <global-header .active=${projectsMatch ? 'projects' : ''}></global-header>
      <main>
        <projects-physics .release=${projectId}></projects-physics>
        <projects-page
          .hidden=${!projectsMatch || projectId}
          .projects=${this.projects}
        ></projects-page>
        ${projectId
          ? html`
              <project-page
                .project=${project}
                imageX="${imageX}"
                imageY="${imageY}"
                imageW="${imageW}"
                imageH="${imageH}"
              ></project-page>
            `
          : ''}
      </main>
    `;
  }
}
